// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3k1e6","logoWrapper":"Header_logoWrapper__3hgc1","logo":"Header_logo__B59QK","nav":"Header_nav__2_bmN"};